import React, { memo, forwardRef } from 'react';

const MapContainer: React.ForwardRefRenderFunction<HTMLElement, {}> = (
  _props,
  ref
  // @ts-ignore
) => <div ref={ref} id="map" style={{ width: '100%', height: '100%' }}></div>;

export default memo(forwardRef(MapContainer));
